//
// Baseline style for most components
//
import { css } from 'styled-components';
export var rootStyle = function rootStyle() {
  return css(["box-sizing:border-box;font-family:var(--font-family,spotify-circular),Helvetica,Arial,sans-serif;-webkit-tap-highlight-color:transparent;"]);
};